import * as React from "react"
import {Box} from "@chakra-ui/react";
import Caret from "../../../../images/caret.svg";

export default function CustomTextLink(props){

    const text = props.text
    const link = props.link

    const paddingL = (props.variant !== undefined && props.variant === 'reverse') ? '50px' : '0'

    const rotationDefault = (props.variant !== undefined) ? props.variant : 'normal'

    const rotation = [
        {
            normal : 'rotate(270deg)',
            reverse : 'rotate(90deg)',
            downwards : 'rotate(180deg)',
        }
    ]

    return(
        <Box as={'a'} href={link}
                fontSize = {{base: '14px', xxl: '18px'}}
                display={'flex'}
                fontWeight= 'bold'
                color= 'brand.lightBlue'
                lineHeight= {{base: '24px', xxl: '32px'}}
                alignItems={'center'}
                position= 'relative'
                width= 'auto'
                paddingRight={{base:'22px', md:'30px'}}
                paddingLeft={paddingL}
                transition={'all 0.3s ease-out'}
                _hover = {{
                    'svg' : {
                        right: '-15px !important'
                    }
                }}
                {...props}
        >
            {(props.variant !== undefined && props.variant === 'reverse') &&
                <Box as={Caret} height={'12px'} top = {{base: '6px', lg: '5px', xxl:'10px'}} style={{
                    fill: '#336699',
                    transform: rotation[0][rotationDefault],
                    transition: 'all 0.3s ease-out',
                    position: 'absolute',
                    left: '0'
                }}/>
            }
            {text}
            {(props.variant === undefined || props.variant !== 'reverse') &&
                <Box as={Caret} height={'12px'} top = {{base: '6px', lg: '7px', xxl:'10px'}} style={{
                    fill: '#336699',
                    transform: rotation[0][rotationDefault],
                    transition: 'all 0.3s ease-out',
                    position: 'absolute',
                    right: '5px'
                }}/>
            }
        </Box>
    )
}